<script lang="ts">
	import FooterV2 from '$lib/layout/footerV2.svelte';
	import BlogHeader from '$lib/blogHeader.svelte';

	let { data, children } = $props();
</script>

<div class="bg-white">
	<div style="padding-top: var(--header-height)" class="transition-padding ease-out">
		{@render children?.()}
	</div>

	<FooterV2 />
</div>

<BlogHeader data={data.header} />
